module.exports = "https://web-assets.ifttt.com/packs/media/icons/lightning-5fcf9c6f.png";